import { addExternalScript } from '../../../../businesscloud/js/includes/utils';
import { headerAd } from './headerAd';
import { inArticleAd } from './inArticleAd';
import { inCopyAd } from './inCopyAd';
import { inCopyTwoAd } from './inCopyTwoAd';

/* ------------------------------------------------------------ */
/* -- Ad Init -- */
/* ------------------------------------------------------------ */
const adInit = () => {
  addExternalScript({ src: 'https://lib.wtg-ads.com/publisher/techblast.co.uk/techblast_sb_ad.js', async: true }).catch(err =>
    console.error(err),
  );
  /* Header Ad */
  headerAd();
  /* Post Ad */
  inArticleAd();
  inCopyAd();
  inCopyTwoAd();
};

export default adInit;
